import { __decorate } from "tslib";
import { provide } from 'inversify-binding-decorators';
export const DebugLogServiceSymbol = Symbol.for('DebugLogService');
let DebugLogService = class DebugLogService {
    constructor() {
        this.debug = false;
    }
    $log(...params) {
        if (this.debug) {
            console.log(...params);
        }
    }
};
DebugLogService = __decorate([
    provide(DebugLogServiceSymbol)
], DebugLogService);
export { DebugLogService };
